/**
 * Color theme. "Doux" = dark, "Clair" = light. Values are the strings persisted
 * in localStorage and reflected on the <html data-theme> attribute.
 */
export enum Theme {
  Doux = 'doux',
  Clair = 'clair',
}
